import React, { useState } from "react";
import Flash from "../images/lightning.svg";
import Backtest from "../images/backtest.svg";
import Analyse from "../images/shield.svg";
import Balance from "../images/balance.svg";
import Rocket from "../images/rocket.svg";
import Strategy from "../images/strategy_builder.svg";
import { Link } from "react-router-dom";
import "../css/LandingPage.css";
import useAuthPopup from "./useAuthPopup";
import MultiStepForm from "./MultiStepForm";
const Features = () => {
  const { isPopupOpen, handleOpenPopup, handleClosePopup } = useAuthPopup();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const questions = [
    "Do you charge any extra brokerage per order?",
    "I have a feature request, where should I reach out?",
  ];

  const answers = [
    "No, you only pay what you are paying for your broker!",
    "You can reach out to our inbox through mail hello@optiongeeks.in, provide us with a brief of your feature request, and we will surely try to integrate it!",
  ];

  const handleToggleAnswer = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <>
      <div className="grid-container  pt-3 pt-md-0">
        {isPopupOpen && <div className="popup-backdrop"></div>}
        <div className="features-h1 mb-3">Why OptionGeeks?</div>
        <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
          <div className="box-title d-flex align-items-center gap-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="27"
              viewBox="0 0 22 27"
              fill="none">
              <path
                d="M11 1L1 16.9091H11V26L21 10.0909H11V1Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>Speed</div>
          </div>
          <div className="box-description">
            Fastest computation of data, you would love the speed!
          </div>
        </div>
        <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
          <div className="box-title d-flex align-items-center gap-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none">
              <path
                d="M15.6212 11.0758C15.9141 10.7829 15.9141 10.308 15.6212 10.0151C15.3283 9.72223 14.8535 9.72223 14.5606 10.0151L15.6212 11.0758ZM10.25 2.81818C10.25 3.2324 10.5858 3.56818 11 3.56818C11.4142 3.56818 11.75 3.2324 11.75 2.81818H10.25ZM19.1818 10.25C18.7676 10.25 18.4318 10.5858 18.4318 11C18.4318 11.4142 18.7676 11.75 19.1818 11.75V10.25ZM2.81818 11.75C3.2324 11.75 3.56818 11.4142 3.56818 11C3.56818 10.5858 3.2324 10.25 2.81818 10.25V11.75ZM5.16669 3.19694C4.8738 2.90405 4.39893 2.90405 4.10603 3.19694C3.81314 3.48984 3.81314 3.96471 4.10603 4.2576L5.16669 3.19694ZM5.39168 5.54325C5.68458 5.83614 6.15945 5.83614 6.45234 5.54325C6.74524 5.25036 6.74524 4.77548 6.45234 4.48259L5.39168 5.54325ZM18.2705 4.2576C18.5634 3.96471 18.5634 3.48984 18.2705 3.19694C17.9776 2.90405 17.5027 2.90405 17.2098 3.19694L18.2705 4.2576ZM15.9242 4.48259C15.6313 4.77548 15.6313 5.25036 15.9242 5.54325C16.2171 5.83614 16.692 5.83614 16.9848 5.54325L15.9242 4.48259ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75ZM11.5303 15.1667L15.6212 11.0758L14.5606 10.0151L10.4697 14.106L11.5303 15.1667ZM10.25 1V2.81818H11.75V1H10.25ZM21 10.25H19.1818V11.75H21V10.25ZM2.81818 10.25H1V11.75H2.81818V10.25ZM4.10603 4.2576L5.39168 5.54325L6.45234 4.48259L5.16669 3.19694L4.10603 4.2576ZM17.2098 3.19694L15.9242 4.48259L16.9848 5.54325L18.2705 4.2576L17.2098 3.19694ZM3.27273 17.3636C3.84889 17.8438 3.84862 17.8441 3.84836 17.8444C3.84829 17.8445 3.84804 17.8448 3.84789 17.845C3.84758 17.8453 3.84732 17.8457 3.84708 17.8459C3.84661 17.8465 3.84628 17.8469 3.84607 17.8471C3.84567 17.8476 3.84581 17.8474 3.84648 17.8467C3.84783 17.8451 3.85135 17.8411 3.85705 17.8347C3.86846 17.8221 3.88862 17.8002 3.91772 17.7704C3.97594 17.7107 4.06986 17.6195 4.20116 17.5069C4.46375 17.2819 4.87548 16.9718 5.45005 16.6584C6.59493 16.0339 8.40384 15.3864 11 15.3864V13.8864C8.14161 13.8864 6.08689 14.6024 4.73177 15.3416C4.05634 15.71 3.55898 16.0818 3.22497 16.3681C3.05798 16.5112 2.93173 16.633 2.84436 16.7225C2.80066 16.7673 2.76666 16.804 2.74211 16.8313C2.72984 16.8449 2.71993 16.8562 2.71235 16.865C2.70855 16.8693 2.70535 16.8731 2.70272 16.8762C2.7014 16.8777 2.70023 16.8791 2.69921 16.8803C2.69869 16.8809 2.69822 16.8815 2.69778 16.882C2.69756 16.8823 2.69725 16.8827 2.69714 16.8828C2.69685 16.8832 2.69656 16.8835 3.27273 17.3636ZM11 15.3864C13.5962 15.3864 15.4051 16.0339 16.55 16.6584C17.1245 16.9718 17.5363 17.2819 17.7988 17.5069C17.9301 17.6195 18.0241 17.7107 18.0823 17.7704C18.1114 17.8002 18.1315 17.8221 18.1429 17.8347C18.1487 17.8411 18.1522 17.8451 18.1535 17.8467C18.1542 17.8474 18.1543 17.8476 18.1539 17.8471C18.1537 17.8469 18.1534 17.8465 18.1529 17.8459C18.1527 17.8457 18.1524 17.8453 18.1521 17.845C18.152 17.8448 18.1517 17.8445 18.1516 17.8444C18.1514 17.8441 18.1511 17.8438 18.7273 17.3636C19.3034 16.8835 19.3032 16.8832 19.3029 16.8828C19.3027 16.8827 19.3024 16.8823 19.3022 16.882C19.3018 16.8815 19.3013 16.8809 19.3008 16.8803C19.2998 16.8791 19.2986 16.8777 19.2973 16.8762C19.2947 16.8731 19.2914 16.8693 19.2877 16.865C19.2801 16.8562 19.2702 16.8449 19.2579 16.8313C19.2333 16.804 19.1993 16.7673 19.1556 16.7225C19.0683 16.633 18.942 16.5112 18.775 16.3681C18.441 16.0818 17.9437 15.71 17.2682 15.3416C15.9131 14.6024 13.8584 13.8864 11 13.8864V15.3864Z"
                fill="#1E2028"
              />
            </svg>
            <div>Analyse</div>
          </div>
          <div className="box-description">
            Wide range of tools to help you analyse markets
          </div>
        </div>
        <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
          <div className="box-title d-flex align-items-center gap-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="13"
              viewBox="0 0 22 13"
              fill="none">
              <path
                d="M12.585 1L21 1.00004M21 1.00004L21 9.45937M21 1.00004L12.4846 9.28973L8.27703 4.96878L1 12"
                stroke="#1E2028"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>Execute</div>
          </div>
          <div className="box-description">
            Execute orders directly in your broker post analysis
          </div>
        </div>
        <div className="why-op-box d-flex flex-column gap-2 justify-content-center px-3">
          <div className="box-title d-flex align-items-center gap-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="17"
              viewBox="0 0 22 17"
              fill="none">
              <path
                d="M11.0002 11.5882V15.1176M11.0002 15.1176C12.4314 15.1176 14.6366 16 14.6366 16M11.0002 15.1176C9.56907 15.1176 7.36385 16 7.36385 16M1.00021 11.1471V1.44118C1.00021 1.19752 1.19804 1 1.44908 1C3.97524 1 16.4518 1 20.5488 1C20.7999 1 21.0002 1.19752 21.0002 1.44118V11.1471C21.0002 11.3907 20.7999 11.5882 20.5488 11.5882C16.4518 11.5882 3.97524 11.5882 1.44908 11.5882C1.19804 11.5882 1.00021 11.3907 1.00021 11.1471Z"
                stroke="#1E2028"
                strokeWidth="1.5"
                sstrokeLinecap="round"
              />
            </svg>
            <div>User-friendly</div>
          </div>
          <div className="box-description">
            Takes less than 5 mins to understand the platform
          </div>
        </div>
      </div>
      <div className="grid-container">
        <div className="pricing-section align-self-start">
          <div>
            <div className="pricing-title">Pricing</div>
            <div className="price-desc">
              Introductory pricing till end of March 24
            </div>
          </div>
          <div>
            <div className="strikethrough-text">₹ 499.00/-</div>
            <span className="bold-price">₹ 199.00/-</span>
            <span className="per-month">per month</span>
          </div>
          <div>
          <button
            className="get-started-btn d-flex align-items-center justify-content-center gap-2 mb-1"
            onClick={handleOpenPopup}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="21"
              viewBox="0 0 16 21"
              fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.0455 0.53125L0.795502 13.2188H8.04545V20.4687L15.2954 7.7812H8.0455V0.53125Z"
                fill="white"
              />
            </svg>
            <span>Get started</span>
          </button>
          <div>
            <span className="thirty-days">30 day’s free trail,</span>
            <span className="no-credit"> no credit cards required</span>
          </div>
          </div>
        </div>

        <div className="get-all-this align-self-start">
          <div className="pricing-title mb-4">Get all of this!</div>
          <div className="d-flex list-box">
            <ul className="custom-list">
              <li>Strategy creator</li>
              <li>Position analytics</li>
              <li>Unlimited orders</li>
              <li>Realtime market feed</li>
              <li>Realtime OI</li>
              <li>Basket order</li>
              <li>Instrument screener</li>
            </ul>
            <ul className="custom-list">
              <li>Prebuilt strategies</li>
              <li>Scalp orders</li>
              <li>Iceberg orders</li>
              <li>Option chain</li>
              <li>Manage orders</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="grid-container">
        <div className="faq-right align-self-start">
          <div className="pricing-title">FAQ’s</div>
          <div className="price-desc">
            Have more questions, feel free to reach out to us!
          </div>
        </div>
        <div className="faq-left align-self-start">
          {questions.map((question, index) => (
            <div
              key={index}
              className={`faq-question ${
                expandedIndex === index ? "expanded" : ""
              }`}
              onClick={() => handleToggleAnswer(index)}>
              <div className="question-container d-flex align-items-center justify-content-between">
                <div>
                  <span className="question-number me-1">{index + 1}. </span>
                  <span className="actual-question">{question}</span>
                </div>

                <span className="arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={`${expandedIndex === index ? "inverted" : ""}`}>
                    <path
                      d="M18.9263 10L11.9631 16.9632L4.99994 10"
                      stroke="#14142B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
              {expandedIndex === index && (
                <div className="faq-answer">{answers[index]}</div>
              )}
            </div>
          ))}
        </div>
      </div>
      {isPopupOpen && <MultiStepForm onClose={handleClosePopup} />}
    </>
  );
};

export default Features;
